import { axios } from '@/utils/request';
//短信查询
const shortMessageList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_SMSBIZ + '/sms/find',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//单条发送
const shortMessageAdd = params => {
  return axios({
    url: process.env.VUE_APP_CMS_SMSBIZ + '/sms/send',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//excel模板下载
const shortMessageUrl = params => {
  return axios({
    url: process.env.VUE_APP_CMS_SMSBIZ + '/sms/getExcelTemplateUrl',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//短信重发
const shortMessageRetransmission = params => {
  return axios({
    url: process.env.VUE_APP_CMS_SMSBIZ + '/sms/resend',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
export {
  shortMessageList,
  shortMessageAdd,
  shortMessageUrl,
  shortMessageRetransmission
};
